export default __webpack_public_path__ + "2915c7875a101876bb08860c603ca3e7.png";